import { render, staticRenderFns } from "./intrastate_booking_report_tbn.vue?vue&type=template&id=4222d1ec&scoped=true&"
import script from "./intrastate_booking_report_tbn.vue?vue&type=script&lang=js&"
export * from "./intrastate_booking_report_tbn.vue?vue&type=script&lang=js&"
import style0 from "./intrastate_booking_report_tbn.vue?vue&type=style&index=0&id=4222d1ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4222d1ec",
  null
  
)

export default component.exports